module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Backup and notes":"Backup and notes","Chapter":"Chapter","Notes":"Notes","Backup":"Backup"},"fr":{"Backup and notes":"Notes & sauvegardes","Chapter":"Chapitre","Notes":"Notes","Backup":"Sauvegarde"}}')
  delete Component.options._Ctor
}
